import type { GdprFeatureConfig } from './type';

export const gdpr: Partial<GdprFeatureConfig> = {
    reloadGeorgeAfterUpdate: true,
};
